import { http } from './http';

export interface ReactionsResponse {
  reactions: Reaction[];
}

export interface Reaction {
  person: Person;
  company: Company;
  reaction: string;
  datetime: string;
}

export interface Person {
  uuid: string;
  slug: string;
  full_name: string;
  avatar: string;
}

export interface Company {
  slug: string;
  name: string;
}

export const addReaction = (type, slug, reaction) => {
  return http.post('/reactions/add', { type, uuid: slug, reaction });
};

export const removeReaction = (type, slug, reaction) => {
  return http.post('/reactions/remove', { type, uuid: slug, reaction });
};

export const getTickerTape = () => {
  return http.get('/reactions/ticker');
};

export const getReactionsObject = (slug, type) => {
  return http.get<ReactionsResponse>(`/reactions/object`, { type, uuid: slug });
};

export const getReactionsPerson = (slug) => {
  return http.get(`/reactions/person`, { uuid: slug });
};
